import React, { useState, useEffect } from 'react';
import Layout from '../../common/components/Navbar'; // <--- Imported Layout
import {
  Title,
  Paper,
  Table,
  Group,
  TextInput,
  Select,
  LoadingOverlay,
  Stack,
  Badge
} from '@mantine/core';
import { DatePickerInput } from '@mantine/dates';
import { IconSearch, IconFilter } from '@tabler/icons-react';
import axios from '../../api/axios';
import Swal from 'sweetalert2';
import '@mantine/dates/styles.css';

const ActionLogs = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  
  const [search, setSearch] = useState('');
  const [userType, setUserType] = useState('');
  const [moduleFilter, setModuleFilter] = useState('');
  const [dateRange, setDateRange] = useState([null, null]);

  const fetchLogs = async () => {
    setLoading(true);
    try {
      const params = {};
      if (search) params.search = search;
      if (userType) params.userType = userType;
      if (moduleFilter) params.module = moduleFilter;
      if (dateRange[0]) params.startDate = dateRange[0];
      if (dateRange[1]) params.endDate = dateRange[1];

      const response = await axios.get('/api/logs', { params });
      setLogs(response.data);
    } catch (error) {
      console.error(error);
      Swal.fire('Error', 'Failed to fetch logs', 'error');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      fetchLogs();
    }, 500);
    return () => clearTimeout(timeoutId);
  // eslint-disable-next-line
  }, [search, userType, moduleFilter, dateRange]);

  const rows = logs.map((log) => (
    <Table.Tr key={log._id}>
      <Table.Td style={{ fontSize: '0.85rem', whiteSpace: 'nowrap' }}>
        {new Date(log.timestamp).toLocaleString()}
      </Table.Td>
      <Table.Td>
        <Badge variant="outline" color="gray">{log.userType}</Badge>
      </Table.Td>
      <Table.Td fw={500}>{log.username}</Table.Td>
      <Table.Td>{log.module}</Table.Td>
      <Table.Td>{log.action}</Table.Td>
      <Table.Td style={{ color: 'gray', fontSize: '0.9rem' }}>{log.details}</Table.Td>
    </Table.Tr>
  ));

  return (
    <Layout>
      <Stack>
        <Title order={2}>System Action Logs</Title>

        <Paper shadow="sm" p="md" radius="md" withBorder>
          <Group align="flex-end" mb="lg">
            <TextInput
              label="Search"
              placeholder="Username or Action..."
              leftSection={<IconSearch size={16} />}
              value={search}
              onChange={(e) => setSearch(e.currentTarget.value)}
              style={{ flex: 1 }}
            />
            <Select
              label="User Type"
              placeholder="All Roles"
              data={['super_admin', 'admin', 'staff', 'resident']}
              value={userType}
              onChange={setUserType}
              clearable
            />
            <Select
              label="Module"
              placeholder="All Modules"
              data={['Auth', 'User Management', 'Billing', 'Residents', 'Complaints']}
              value={moduleFilter}
              onChange={setModuleFilter}
              clearable
              leftSection={<IconFilter size={16} />}
            />
            <DatePickerInput
              type="range"
              label="Date Range"
              placeholder="Pick dates"
              value={dateRange}
              onChange={setDateRange}
              clearable
              style={{ flex: 1 }}
            />
          </Group>

          <div style={{ position: 'relative', minHeight: 300 }}>
            <LoadingOverlay visible={loading} />
            <Table striped highlightOnHover stickyHeader>
              <Table.Thead>
                <Table.Tr>
                  <Table.Th>Date & Time</Table.Th>
                  <Table.Th>Role</Table.Th>
                  <Table.Th>Username</Table.Th>
                  <Table.Th>Module</Table.Th>
                  <Table.Th>Action</Table.Th>
                  <Table.Th>Details</Table.Th>
                </Table.Tr>
              </Table.Thead>
              <Table.Tbody>
                {rows.length > 0 ? rows : (
                  <Table.Tr>
                    <Table.Td colSpan={6} align="center">No logs found</Table.Td>
                  </Table.Tr>
                )}
              </Table.Tbody>
            </Table>
          </div>
        </Paper>
      </Stack>
    </Layout>
  );
};

export default ActionLogs;